import { useCallback, useEffect, useState } from 'react';
import { useEventListener } from '../../../utils/hooks';

const useInFocusNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const slideNavigationKeys = ['ArrowUp', 'ArrowDown', 'ArrowRight', 'ArrowLeft', 'Space', 'Enter'];

  const handleKeydown = useCallback((event: KeyboardEvent) => {
    if (!document.activeElement) return;
    if (document.activeElement.tagName.toLowerCase() !== 'body') return;

    if (slideNavigationKeys.includes(event.code)) {
      setIsVisible(true);
      return;
    }
    setIsVisible(false);
  }, []);

  useEventListener('keydown', handleKeydown);

  useEffect(() => {
    if (!isVisible) return;

    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [isVisible]);
  return { isVisible };
};

export default useInFocusNotification;
